// @flow
import styled from 'styled-components';

export const BlankPlayerLabel = styled.p`
	justify-self: center;
	margin: auto;
	font-size: 14px;
	font-weight: bold;
	color: #C0C0C0;
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
`;

export default BlankPlayerLabel;


// WEBPACK FOOTER //
// ./src/pages/league/team/blankPlayerLabel.js